import { motion } from 'framer-motion';
import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Fade-up route transition. AnimatePresence intentionally omitted — when
 * paired with `mode="wait"` and short routes, it can leave the
 * scroll container sized to the previous (longer) route, producing phantom
 * empty space below the new page's content.
 */
export function PageTransition({ children }: { children: ReactNode }) {
  const location = useLocation();
  return (
    <motion.div
      key={location.pathname}
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.28, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
}
